var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application" },
    [
      _vm.hasErrors
        ? [_c("h2", [_vm._v(_vm._s(_vm.$t("ticketList.error")))])]
        : [
            _c("header-icons", { staticClass: "ticketShop-icons" }),
            _vm._v(" "),
            _vm.events.length > 1
              ? _c("div", { staticClass: "SingleSelect" }, [
                  _c("div", { staticClass: "input" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t("ticketList.selectEvent")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "selectWrapper icon icon-arrow-right" },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventSelection,
                                expression: "eventSelection",
                              },
                            ],
                            staticClass: "SingleSelect form-control",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.eventSelection = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                _vm.update,
                              ],
                            },
                          },
                          _vm._l(_vm.events, function (event) {
                            return _c(
                              "option",
                              { domProps: { value: event } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$tm(event, "descriptionExternal"))
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.eventSelection && _vm.eventSelection.useFilterInTicketlist
              ? [
                  _c(
                    "h4",
                    {
                      staticClass: "filter-title bold",
                      class: { filtered: _vm.productGroups.length >= 1 },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("ticketList.filter.headline"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.eventSelection && _vm.eventSelection.useFilterInTicketlist
                    ? _c(
                        "div",
                        { staticClass: "product-group-filter-container" },
                        _vm._l(_vm.productGroups, function (productGroup) {
                          return _c(
                            "div",
                            { staticClass: "product-group-filter" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "product-group-filter-button button",
                                  class: {
                                    selected:
                                      _vm.selectedProductGroup === productGroup,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSelectedProductGroup(
                                        productGroup
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(productGroup.title) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "product-group-filter-reset",
                      class: { filtered: _vm.isFiltered },
                      on: {
                        click: function ($event) {
                          return _vm.updateSelectedProductGroup(null)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("ticketList.filter.reset")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "grid grid__ticketList",
                attrs: { id: "ticketList" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "grid__item grid__item--65 tickets tickets--list",
                  },
                  [
                    _c("spinner", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.ticketConfigurations.length === 0 &&
                            _vm.loading,
                          expression:
                            "ticketConfigurations.length === 0 && loading",
                        },
                      ],
                    }),
                    _vm._v(" "),
                    _c("spinner", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.ticketConfigurations.length !== 0 &&
                            _vm.loading,
                          expression:
                            "ticketConfigurations.length !== 0 && loading",
                        },
                      ],
                      staticClass: "spinner--absolute",
                    }),
                    _vm._v(" "),
                    _vm.ticketConfigurations.length === 0 && !_vm.loading
                      ? [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("ticketList.noAvailableProducts"))
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      _vm.ticketConfigurations,
                      function (ticketConfiguration, outerKey) {
                        return [
                          _vm.isConfigurationCollection(ticketConfiguration) &&
                          ticketConfiguration.ticketConfigurations[0]
                            ? [
                                !_vm.availableSubProductIds.includes(
                                  ticketConfiguration.ticketConfigurations[0]
                                    .product.id
                                )
                                  ? [
                                      _c(
                                        "ticket-configuration-collection-item",
                                        {
                                          key: ticketConfiguration.id,
                                          attrs: {
                                            loading: _vm.loading,
                                            ticketConfigurationCollection:
                                              ticketConfiguration,
                                            selectedSlots: _vm.selectedSlots,
                                            "products-prop": _vm.products,
                                            "on-site-products":
                                              _vm.onSiteProductsMapping[
                                                ticketConfiguration
                                                  .ticketConfigurations[0]
                                                  .product.id
                                              ],
                                            "slots-prop": _vm.slots,
                                          },
                                          on: {
                                            incrementQuantity:
                                              _vm.incrementQuantity,
                                            decrementQuantity:
                                              _vm.decrementQuantity,
                                            selectSlot: _vm.selectSlot,
                                            onSlotSelectionModalOpen:
                                              _vm.onSlotSelectionModalOpen,
                                            addPreselectionToCart:
                                              _vm.addPreselectionToCart,
                                            changeSelection:
                                              _vm.changeSelection,
                                          },
                                        }
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            : [
                                !_vm.availableSubProductIds.includes(
                                  ticketConfiguration.product.id
                                )
                                  ? [
                                      _c("ticket-configuration-item", {
                                        key: ticketConfiguration.id,
                                        attrs: {
                                          loading: _vm.loading,
                                          ticketConfiguration:
                                            ticketConfiguration,
                                          "products-prop": _vm.products,
                                          "on-site-products":
                                            _vm.onSiteProductsMapping[
                                              ticketConfiguration.product.id
                                            ],
                                          "slots-prop": _vm.slots,
                                        },
                                        on: {
                                          incrementQuantity:
                                            _vm.incrementQuantity,
                                          decrementQuantity:
                                            _vm.decrementQuantity,
                                          addToCart: _vm.addToCart,
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                        ]
                      }
                    ),
                    _vm._v(" "),
                    _vm.cartPage &&
                    _vm.ticketConfigurations.length !== 0 &&
                    !_vm.loading
                      ? _c("div", { staticClass: "ticketList__toCart" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "ticketList__toCartLink button button-inverted",
                              class: { disabled: !_vm.itemInShopper },
                              attrs: {
                                href: _vm.itemInShopper
                                  ? _vm.cartPage
                                  : "javascript:void(0);",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("global.links.toShoppingCart")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "grid__item grid__item--35 grid__item--last ticketCode",
                  },
                  [
                    _c("div", { staticClass: "ticketCode__line" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "openingTimes__box",
                        attrs: { id: "opening-times" },
                      },
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("ticketList.openingTimes.headline"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.openingTimes.length
                          ? _vm._l(_vm.openingTimes, function (period) {
                              return _c("p", {
                                staticClass: "ticket__descriptionSubtitle",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getFormattedDate(period)
                                  ),
                                },
                              })
                            })
                          : [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("ticketList.openingTimes.missing")
                                  )
                                ),
                              ]),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ticketCode__box",
                        attrs: { id: "ticket-code" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "input" },
                          [
                            _c(
                              "p",
                              { staticClass: "h3 ticketCode__boxHeadline" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("ticketList.ticketCode.headline")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "ticketCode__boxText",
                                attrs: { for: "" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("ticketList.ticketCode.subHeadline")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                staticClass:
                                  "ticketCode__boxInput form__group form__group--input",
                                on: {
                                  submit: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.redeemCode.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim.lazy",
                                      value: _vm.newUserCode,
                                      expression: "newUserCode",
                                      modifiers: { trim: true, lazy: true },
                                    },
                                  ],
                                  staticClass:
                                    "ticketCode__boxInputElement input input--input",
                                  attrs: { id: "", type: "text" },
                                  domProps: { value: _vm.newUserCode },
                                  on: {
                                    change: function ($event) {
                                      _vm.newUserCode =
                                        $event.target.value.trim()
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.newUserCodeIsPromotion
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "ticketList.ticketCode.promotionCodeInShop",
                                        { invalidCode: _vm.lastUserCode }
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errorCode
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("errorCodes." + _vm.errorCode)
                                    )
                                  ),
                                ])
                              : _vm.newUserCodeError
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "ticketList.ticketCode.invalidCode",
                                        { invalidCode: _vm.lastUserCode }
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.codeLoading
                              ? [
                                  _c("spinner", {
                                    staticClass: "spinner--white",
                                  }),
                                ]
                              : [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "ticketCode__boxButton button",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.redeemCode.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ticketList.ticketCode.redeemCode"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "payment__images" },
                      [
                        _vm._l(_vm.paymentChoices, function (payment) {
                          return [
                            payment.value === "creditcard"
                              ? [
                                  _c("img", {
                                    staticClass: "mastercard",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/mastercard.png",
                                      alt: "mastercard",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "visa",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/visa.png",
                                      alt: "visa",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            payment.value === "paypal"
                              ? [
                                  _c("img", {
                                    staticClass: "paypal",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/paypal.png",
                                      alt: "paypal",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            payment.value === "sepa"
                              ? [
                                  _c("img", {
                                    staticClass: "paypal",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/SepaLogo.svg",
                                      alt: "sepa",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            payment.value === "paydirekt"
                              ? [
                                  _c("img", {
                                    staticClass: "giropay paypal",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/paydirekt.svg",
                                      alt: "paydirekt",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "ticketList-agb-privacy" }, [
                      _c(
                        "div",
                        { staticClass: "privacyStatement" },
                        [
                          _vm.eventSelection &&
                          _vm.privacyStatements[
                            "" + _vm.eventSelection.clientId
                          ]
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "inline-link privacyStatement-link",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.openPrivacyModal()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "privacy.client.privacyStatement2"
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "inline-link privacyStatement-link",
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.i18nPrivacyStatementLink,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "privacy.client.privacyStatement2"
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "privacyStatement" },
                        [
                          _vm.eventSelection &&
                          _vm.agb["" + _vm.eventSelection.clientId]
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "inline-link privacyStatement-link",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.openAGBModal()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("privacy.agb.agbOf"))
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "a",
                                  {
                                    staticClass: "privacyStatement-link",
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.i18nTermsAndConditionsLink,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("privacy.agb.agbOf"))
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "25px" } }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("ticketList.includingVAT"))),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "Modal",
                  { ref: "privacyModal" },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      [
                        _vm.selectedPrivacyStatement
                          ? [
                              _c("div", {
                                staticClass: "privacyModal",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.i18nPrivacyStatementContent
                                  ),
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "Modal",
                  { ref: "agbModal" },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      [
                        _vm.selectedAGB
                          ? [
                              _c("div", {
                                staticClass: "privacyModal",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.i18nTermsAndConditionsContent
                                  ),
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }